<template>
  <Modal ref="modal" title="Quantitativos de Fotos Registradas" @cancel="close">
    <form class="export-container" @submit.prevent="handleSubmit">
      <SingleDate legend="Insira a data" :modelValue="day" @update:modelValue="$event => (this.day = $event)" />

      <div class="format-container">
        <span>Em qual formato de exportação?</span>

        <RadioButtons :options="radioOptions" name="format" :modelValue="type"
          @update:modelValue="$event => this.type = $event" />
      </div>

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import SingleDate from 'core/SingleDate'
import RadioButtons from 'core/RadioButtons'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'QuantitativosFotosModal',
  components: {
    Modal,
    SingleDate,
    RadioButtons,
    Button,
    TrayArrowDown,
  },
  data() {
    return {
      type: 'teoricas',
      day: '',
      loading: false,
      radioOptions: [
        { value: "teoricas", label: "Planilha de Fotos Teóricas" },
        { value: "praticas", label: "Planilha de Fotos Práticas" },
      ],
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()

      this.day = ''
      this.type = 'teoricas'
      this.loading = false
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const params = {
        day: this.day,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/export/planilha/aulas/${this.type}/quantidade-fotos`, {
        params,
      })
        .then((res) => {
          _export.downloadCSV(res.body.arquivo, `${this.type}-quantidade-fotos`)
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if (!this.day) {
        this.$toasted.show('O campo de data é obrigatório.', {
          icon: 'fa-times',
          position: 'top-right',
        })

        return false
      }

      return true
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 40vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>